<template>
  <v-dialog v-model="show" max-width="800px" scrollable>
    <v-card>
      <div v-show="isSuccessEditOrCreate === true" class="pa-5">
        <div class="succes_box">
          <v-icon size="35" color="green">check</v-icon>
          <p>Éxito al {{ isEdit ? 'editar' : 'crear' }} ajuste</p>
        </div>
      </div>
      <div v-show="errorMsg !== undefined && loading === false" class="pa-5">
        <v-icon @click="close" class="close">close</v-icon>
        <div class="error_msg">
          <v-icon color="red">warning</v-icon>
          <div>
            <span>{{ errorMsg }}</span>
          </div>
        </div>
      </div>
      <div v-show="loading === true && errorMsg === undefined" class="pa-5">
        <v-icon @click="close" class="close">close</v-icon>
        <div class="lds-dual-ring"></div>
      </div>
      <div
        v-show="
          loading === false &&
          errorMsg === undefined &&
          isSuccessEditOrCreate === false
        "
        class="main_box"
        @click="hide"
      >
        <v-icon @click="close" class="close">close</v-icon>
        <v-card-title class="modal_title pa-4">
          <v-icon color="primary" class="mr-2">settings</v-icon>
          <p class="modal_title-title">
            {{ title }}
          </p>
        </v-card-title>
        <v-card-text class="mb-3">
          <div class="custom_box px-4 py-3">
            <div class="custom_switch">
              <span class="mr-4">Recepción de reportes por correo</span>
              <v-switch color="primary" v-model="receiveReports"></v-switch>
            </div>
            <p class="email_text">Correo electrónico</p>
            <div class="custom_box-middle">
              <div class="box1">
                <input
                  v-if="selectedEmail === undefined"
                  type="email"
                  v-model="newEmail"
                  @keyup.enter="addEmailFromForm"
                />
                <input
                  v-if="selectedEmail !== undefined"
                  type="email"
                  v-model="selectedEmail.text"
                  @keyup.enter="addEmailFromForm"
                />
                <p class="email_warning" v-show="showEmailWarning">
                  El correo es inválido
                </p>
              </div>
              <div class="box2">
                <button
                  :disabled="!isValidAddEmailFromForm()"
                  @click="addEmailFromForm"
                >
                  <v-icon
                    size="35"
                    :color="!isValidAddEmailFromForm() ? 'grey ' : 'primary'"
                  >
                    add
                  </v-icon>
                </button>
              </div>
              <div class="box3">
                <div class="list_emails">
                  <ul>
                    <li v-for="email in emails" close :key="email.id">
                      <v-chip class="mr-4">
                        <!-- <input
                          v-if="email.focus"
                          type="email"
                          v-model="email.text"
                          @keyup.enter="focusEmail($event, email)"
                          :disabled="
                            selectedEmail !== undefined &&
                            selectedEmail.id !== email.id
                          "
                        /> -->
                        <span>
                          {{ email.text }}
                          <span>
                            {{ _levelsGradesTextParse(email) }}
                          </span>
                        </span>
                        <v-icon
                          size="20"
                          class="mx-1"
                          color="black"
                          @click="focusEmail($event, email)"
                          :disabled="selectedEmail !== undefined"
                        >
                          edit
                        </v-icon>
                        <v-icon
                          size="20"
                          class="mx-1"
                          color="black"
                          @click="removeEmail(email)"
                          :disabled="selectedEmail !== undefined"
                        >
                          cancel
                        </v-icon>
                      </v-chip>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="box4">
                <!-- <div class="custom_drop" ref="host_box">
                  <div class="selected_drop" @click="hideDrop = false">
                    <span class="px-3 py-2">
                      {{ selectedPeriod.text }}
                    </span>
                    <v-icon color="black"> arrow_drop_down </v-icon>
                  </div>
                  <ul :class="['drop', hideDrop ? 'hide' : '']">
                    <li
                      v-for="(period, i) in possiblePeriods"
                      :key="period.value"
                    >
                      <button
                        :class="[
                          'ml-3',
                          'period',
                          period.isSelected ? 'selected' : '',
                        ]"
                        @click="selectPeriod(period)"
                      >
                        {{ period.text }}
                      </button>
                      <v-divider
                        v-if="i !== possiblePeriods.length - 1"
                      ></v-divider>
                    </li>
                  </ul>
                </div> -->
                <p class="mb-1">Periodicidad</p>
                <v-select
                  class="custom_select"
                  height="20"
                  solo
                  flat
                  label="Periodicidad"
                  item-text="text"
                  item-value="value"
                  hide-details
                  :items="possiblePeriods"
                  v-model="selectedPeriod"
                />
                <p class="mb-1">Niveles</p>
                <!-- <v-select
                  class="custom_select"
                  height="20"
                  solo
                  flat
                  multiple
                  label="Niveles"
                  item-text="levelName"
                  item-value="levelId"
                  hide-details
                  :return-object="true"
                  :items="levels"
                  v-model="selectedLevels"
                /> -->
                <SelectFilter
                  label="Niveles"
                  item-name="levelName"
                  :items="levels"
                  :selected-items="selectedLevels"
                  @onSelectedItems="
                    (levels) => {
                      this.selectedLevels = levels
                    }
                  "
                />
                <!-- <v-select
                  class="custom_select"
                  height="20"
                  solo
                  flat
                  multiple
                  label="Niveles"
                  item-text="levelName"
                  item-value="levelId"
                  hide-details
                  :return-object="true"
                  :items="levels"
                  v-model="selectedLevels"
                >
                  <template v-slot:prepend-item>
                    <v-list-tile ripple @click="toggleLevels">
                      <v-list-tile-action>
                        <v-icon
                          :color="selectedLevels.length > 0 ? 'primary' : ''"
                        >
                          {{ iconTotal }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Todos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <div v-if="index === 0">
                      <span v-if="selectedLevels.length === 1">
                        {{ item.levelName }}
                      </span>
                      <span
                        v-else-if="
                          selectedLevels.length > 1 &&
                          selectedLevels.length < levels.length
                        "
                      >
                        (+{{ selectedLevels.length }} filtros)
                      </span>
                      <span v-else-if="selectedLevels.length === levels.length">
                        Todos
                      </span>
                    </div>
                  </template>
                </v-select> -->
                <p class="email_warning" v-show="showLevelsWarning">
                  Agrega al menos un nivel
                </p>
                <p class="mb-1">Grado/Grupo</p>
                <v-select
                  class="custom_select"
                  height="20"
                  solo
                  flat
                  multiple
                  label="Grados"
                  item-text="groupName"
                  item-value="groupId"
                  hide-details
                  :return-object="true"
                  :items="
                    gradeGroups.filter((e) =>
                      selectedLevels.map((e) => e.levelId).includes(e.levelId)
                    )
                  "
                  v-model="selectedGrades"
                />
                <div v-if="isValidAddEmailFromForm()" class="mt-3 d-flex">
                  <v-btn
                    flat
                    @click="addEmailFromForm"
                    class="modal_button primary"
                    style="font-size: inherit"
                  >
                    Guardar
                  </v-btn>
                </div>
                <div v-if="selectedEmail !== undefined" class="mt-3 d-flex">
                  <v-btn
                    flat
                    @click="updateEmail(false)"
                    class="modal_button mr-3"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    flat
                    @click="updateEmail"
                    class="modal_button primary"
                    style="font-size: inherit"
                  >
                    Guardar
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn flat @click="close" class="modal_button"> Cancelar </v-btn>
          <v-btn
            :disabled="isDisablesSaveBtn()"
            flat
            @click="submit"
            class="modal_button"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { EmailUtils } from '../../../utils/genericUtils.js'
import {
  Level,
  parseGroups,
  parseLevels,
} from '../../Routes/Nested_Routes/Students/utils.js'
import SelectFilter from './filter.vue'
import { getPeriod, isDisablesSaveBtn } from './reportSettings.js'

class Email {
  /**
   *
   * @param {{id?:string|number,text?:string, focus?:boolean, levels?:Array<Level>, gradeGroups?:Array<Level>, periodicity:string} } params
   */
  constructor(params = {}) {
    this.id = params.id
    this.text = params.text
    this.focus = params.focus
    this.levels = params.levels
    this.gradeGroups = params.gradeGroups
    this.periodicity = params.periodicity
  }
}

export default {
  props: {
    reportSettingtype: String,
    show: Boolean,
    title: String,
  },
  components: {
    SelectFilter,
  },
  data: () => ({
    /**@type {Email} */
    selectedEmail: undefined,
    /**@type {Array<Level>} */
    levels: [],
    /**@type {Array<Level>} */
    gradeGroups: [],
    showEmailWarning: false,
    showLevelsWarning: false,
    isSuccessEditOrCreate: false,
    isEdit: false,
    idRequest: 0,
    loading: false,
    errorMsg: undefined,
    show: false,
    selectedPeriod: undefined,
    /**@type {Array<Level>} */
    selectedLevels: [],
    /**@type {Array<Level>} */
    selectedGrades: [],
    hideDrop: true,
    receiveReports: false,
    newEmail: '',
    /**
     * @type {Array<Email>}
     */
    emails: [],
    possiblePeriods: [
      { text: 'Diario', value: 'DAILY', isSelected: false },
      { text: 'Semanal', value: 'WEEKLY', isSelected: false },
      { text: 'Mensual', value: 'MONTHLY', isSelected: false },
    ],
  }),
  beforeMount() {
    if (this.selectedPeriod === undefined) {
      this.selectPeriod(this.possiblePeriods.at(0).value)
    }
  },
  methods: {
    isDisablesSaveBtn() {
      return isDisablesSaveBtn(this.selectedEmail, this.newEmail)
    },
    toggleLevels() {
      if (this.selectedLevels.length) this.selectedLevels = []
      else this.selectedLevels = this.levels.map((e) => e).slice()
    },
    /**
     *
     * @param {Email} collaborator
     */
    _levelsGradesTextParse(collaborator) {
      if (collaborator.levels === undefined) {
        return ` - (Todos) - ${this._getPeriod(collaborator.periodicity)}`
      }

      if (collaborator.levels.length === this.levels.length) {
        return ` - (Todos) - ${this._getPeriod(collaborator.periodicity)}`
      }

      return (
        ' - ' +
        collaborator.levels
          .map(
            (level) =>
              `${level.levelName}
            ${
              collaborator.gradeGroups !== undefined
                ? collaborator.gradeGroups.filter(
                    (e) => e.levelId === level.levelId
                  ).length === 0
                  ? ''
                  : '(' +
                    collaborator.gradeGroups
                      .filter((e) => e.levelId === level.levelId)
                      .map((e) => e.groupName)
                      .join(', ') +
                    ')'
                : ''
            }`
          )
          .join(' - ') +
        ` - ${this._getPeriod(collaborator.periodicity)}`
      )
    },
    async _initialState() {
      this.show = false
      await this._sleep(300)
      this.isSuccessEditOrCreate = false
      this.showEmailWarning = false
      this.showLevelsWarning = false
      this.isEdit = false
      this.errorMsg = undefined
      this.loading = false
      this.emails = []
      this.hideDrop = true
      this.receiveReports = false
      this.newEmail = ''
      this.selectedEmail = undefined
      this.selectedLevels = this.levels.map((e) => e)
      this.title = 'Configuración de reporte'
      this.selectPeriod(this.possiblePeriods.at(0).value)
    },
    isValidAddEmailFromForm() {
      if (this.selectedEmail !== undefined) return false

      if (this.newEmail.trim() === '' || this.selectedLevels.length === 0) {
        return false
      }

      if (!EmailUtils.isValidEmail(this.newEmail)) return false

      return true
    },
    isValidUpdateEmailFromForm() {
      if (this.selectedEmail === undefined) return false

      if (
        this.selectedEmail.text.trim() === '' ||
        this.selectedEmail.levels.length === 0
      ) {
        return false
      }

      return true
    },
    addEmailFromForm() {
      if (
        this.newEmail === '' ||
        this.showEmailWarning === true ||
        this.showLevelsWarning === true
      )
        return

      if (this.selectedLevels.length === 0) {
        this.showLevelsWarning = true
        return
      }

      this.emails.push(
        new Email({
          text: this.newEmail,
          focus: false,
          id: Math.random().toString(),
          levels: this.selectedLevels,
          gradeGroups: this.selectedGrades,
          periodicity: this.selectedPeriod,
        })
      )

      this.newEmail = ''
      this.selectPeriod(this.possiblePeriods.at(0).value)
      this.selectedLevels = this.levels.map((e) => e)
      this.selectedGrades = []
    },
    generateEmail(email) {
      let levels = undefined
      let gradeGroups = undefined

      if (email.levels !== undefined) {
        levels = email.levels
          .map((level) => level.id)
          .map((levelId) => this.levels.filter((e) => e.levelId === levelId)[0])
          .filter(Boolean) // REMVOE LEVELS IF NOT EXIST

        gradeGroups = email.levels
          .map((level) => level.groups)
          .flat()
          .filter(Boolean)
          .map((e) => this.gradeGroups.filter((x) => x.groupId === e)[0])
          .filter(Boolean) // REMOVE GROUP/GRADE NOT EXIST
      }

      return new Email({
        periodicity: email.periodicity,
        text: email.email,
        focus: false,
        id: Math.random().toString(),
        levels,
        gradeGroups,
      })
    },
    removeEmail(email) {
      this.emails = this.emails.filter((e) => e.id !== email.id)
    },
    updateEmail(update = true) {
      if (update === false) {
        this.selectedEmail = undefined
        this.selectedLevels = []
        this.selectedGrades = []
        this.showEmailWarning = false
        this.selectedLevels = this.levels.map((e) => e)
        this.showLevelsWarning = false
        return
      }

      if (this.selectedLevels.length === 0) {
        this.showLevelsWarning = true
        return
      }

      const isValidEmail = EmailUtils.isValidEmail(this.selectedEmail.text)
      this.showEmailWarning = isValidEmail === false

      if (isValidEmail === false) return

      this.emails = this.emails.map((e) => {
        if (e.id === this.selectedEmail.id) {
          this.selectedEmail.periodicity = this.selectedPeriod
          this.selectedEmail.levels = this.selectedLevels
          this.selectedEmail.gradeGroups = this.selectedGrades
          this.selectedLevels = []
          this.selectedGrades = []
          this.selectedEmail.focus = false

          return this.selectedEmail
        }

        return e
      })
      this.selectedLevels = this.levels.map((e) => e)
      this.selectedGrades = []
      this.selectedEmail = undefined
      this.selectPeriod(this.possiblePeriods.at(0).value)
    },
    async focusEmail(e, email) {
      e.stopPropagation()
      this.selectedEmail = structuredClone(email)
      this.selectedPeriod = email.periodicity
      this.selectedLevels = email.levels || []

      if (email.levels === undefined) {
        this.selectedLevels = this.levels.map((e) => e)
      }

      this.selectedGrades = email.gradeGroups || []
    },
    selectPeriod(period) {
      this.selectedPeriod = period

      // for (const period of this.possiblePeriods) {
      //   period.isSelected = false
      // }

      // period.isSelected = true
      // this.hideDrop = true
    },
    _getPeriod(period) {
      return getPeriod(this.possiblePeriods, period)
    },
    _sleep(timeInms = 300) {
      return new Promise((res, _) => {
        const y = setTimeout(() => {
          res()
          clearTimeout(y)
        }, timeInms)
      })
    },
    async submit() {
      const isSuccess = await this._callApi()
      await this._sleep(500)
      if (isSuccess) {
        this.closeModal()
      }
    },
    close() {
      this.closeModal()
    },
    closeModal() {
      this.$emit('closeEditSetting', undefined)
    },
    _childOf(childNode, parentNode) {
      while ((childNode = childNode.parentNode) && childNode !== parentNode);
      return !!childNode
    },
    hide() {
      if (this.hideDrop) return
      if (this._childOf(event.target, this.$refs.host_box)) return
      this.hideDrop = true
    },
    _callApi() {
      if (this.isEdit === true) {
        return this._editReportSettings()
      } else {
        return this._createReportSettings()
      }
    },
    _apiDataInfo() {
      return {
        configuration: {
          recipients: this.emails.map((e) => ({
            periodicity: e.periodicity,
            email: e.text,
            levels:
              e.levels === undefined ||
              e.levels.length === 0 ||
              e.levels.length === this.levels.length
                ? undefined
                : e.levels.map((level) => ({
                    id: level.levelId,
                    groups:
                      e.gradeGroups !== undefined && e.gradeGroups.length !== 0
                        ? e.gradeGroups
                            .filter((e) => e.levelId === level.levelId)
                            .map((e) => e.groupId)
                        : undefined,
                  })),
          })),
        },
        // periodicity: this.possiblePeriods[0].value,
        type: this.reportSettingtype,
      }
    },
    async _createReportSettings() {
      try {
        this.loading = true
        await this.$store.dispatch(
          'reports/createReportSettings',
          this._apiDataInfo()
        )
        this.isSuccessEditOrCreate = true
        this.loading = false
        return true
      } catch (error) {
        console.log(error)
        this.loading = false
        if (error.response.status === 400) {
          this.errorMsg = 'Ya existe una configuración'
          return
        }

        if (error.response.status === 404) {
          this.errorMsg = 'Usuario inválido'
          return
        }

        this.errorMsg = 'Error al crear ajuste de reporte'
      }
    },
    async _editReportSettings() {
      const data = {
        ...this._apiDataInfo(),
        enabled: this.receiveReports,
      }

      try {
        this.loading = true
        await this.$store.dispatch('reports/editReportSettings', data)
        this.isSuccessEditOrCreate = true
        this.loading = false
        return true
      } catch (error) {
        console.log(error)
        this.loading = false
        if (error.response.status === 404) {
          this.errorMsg = 'Error 404 tipo de reporte no existentente'
          return
        }

        this.errorMsg = 'Error al editar ajuste de reporte'
      }
    },
    async _setupLevels() {
      try {
        const { data } = await this.$store.dispatch('level/getLevelsWithGroups')
        this.levels = parseLevels({ levels: data })
        this.selectedLevels = this.levels.map((e) => e)
        this.gradeGroups = parseGroups({ gradeGroups: data })
      } catch (error) {
        console.log(error)
        this.errorMsg = 'Error al cargar la información'
      }
    },
    /**
     *
     * @param {number} idReq
     * @param {'ENTRY_DEPARTURE'|'COLLABORATOR_ASSISTANCE'|'STUDENT_DELIVERY'|'STUDENT_ASSISTANCE'} reportSettingtype
     */
    async _getReportSettings(idReq, reportSettingtype) {
      const possibleTypes = [
        'ENTRY_DEPARTURE',
        'COLLABORATOR_ASSISTANCE',
        'STUDENT_DELIVERY',
        'STUDENT_ASSISTANCE',
      ]

      if (possibleTypes.includes(reportSettingtype) === false) {
        this.errorMsg = 'Error al buscar el tipo de reporte'
        console.error('Type not foud')
        return
      }

      const param = {
        type: reportSettingtype,
      }
      this.loading = true
      try {
        const { data } = await this.$store.dispatch(
          'reports/getReportSettings',
          param
        )

        if (this.idRequest !== idReq) return

        // this.selectPeriod(
        //   this.possiblePeriods.find((e) => e.value === data.periodicity)
        // )
        this.receiveReports = data.enabled
        this.emails = data.configuration.recipients.map((e) =>
          this.generateEmail(e)
        )
        this.isEdit = true
      } catch (error) {
        console.log(error)
        if (this.idRequest !== idReq) return

        if (error.response.status !== 404) {
          this.errorMsg = 'Error al solicitar datos'
          this.isEdit = true
          this.loading = false
          return
        }

        this.isEdit = false
      } finally {
        this.loading = false
      }
    },
  },
  computed: {
    selectAllLevels() {
      return this.selectedLevels.length === this.levels.length
    },
    selectSomeLevels() {
      return this.selectedLevels.length > 0 && !this.selectAllLevels
    },
    iconTotal() {
      if (this.selectAllLevels) return 'disabled_by_default'
      if (this.selectSomeLevels) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
  },
  watch: {
    newEmail() {
      if (this.newEmail === '') {
        this.showEmailWarning = false
        return
      }

      const isValidEmail = EmailUtils.regexEmail().test(this.newEmail)
      this.showEmailWarning = isValidEmail === false
    },
    async show() {
      if (this.show === false) {
        this._initialState()
        this.close()
        this.idRequest = Math.random()
      }
      if (this.show === true) {
        await this._setupLevels()
        this._getReportSettings(this.idRequest, this.reportSettingtype)
      }
    },
  },
}
</script>

<style scoped>
/* override css */
::v-deep .v-input.custom_select.v-text-field.v-text-field--enclosed {
  border: 1px solid var(--gray-300, #d1d5db);
  border-radius: 6px;
  padding: 1px;
}
::v-deep .v-input--selection-controls {
  margin: 0;
  padding: 0;
}
::v-deep .v-btn__content {
  text-transform: initial !important;
}
::v-deep
  .v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin: 0;
}
.email_warning {
  font-size: 16px;
  font-weight: 500;
  color: red;
}
.succes_box {
  font-size: 20px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.error_msg {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.main_box {
  position: relative;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
}

.modal_title {
  display: flex;
  align-items: center;
}

.modal_title-title {
  margin: 0;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
}

.modal_button {
  margin: 0;
  width: 100px;
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: capitalize;
}
.custom_box {
  border: 1px solid var(--gray-200, #e5e7eb);
  border-radius: 6px;
}
.custom_box-content {
  padding: 0 70px;
}
.custom_switch {
  display: flex;
  justify-content: start;
}
.custom_switch span {
  color: var(--gray-700, #374151);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.email_text {
  margin: 0;
}
.custom_box-middle {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 5px;
  grid-auto-rows: minmax(100px, auto);
}
.box1 {
  grid-column: 1 / 6;
  grid-row: 1;
}
.box1 input {
  padding: 7px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--gray-300, #d1d5db);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.box2 {
  display: grid;
  grid-column: 6 / 7;
  grid-row: 1;
  justify-content: center;
  align-content: baseline;
}
.box3 {
  grid-column: 7 / 13;
  grid-row: 1/3;
}
.list_emails {
  height: 200px;
  overflow: scroll;
  border-radius: 6px;
  border: 1px solid var(--gray-200, #e5e7eb);
}
.box4 {
  grid-column: 1 / 6;
  grid-row: 2;
}

.custom_drop {
  position: relative;
}
.selected_drop {
  cursor: pointer;
  margin: 0;
  min-height: 15px;
  border: 1px solid var(--gray-300, #d1d5db);
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
}
.period {
  color: var(--gray-500, #6b7280);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 30px;
  width: 100%;
  text-align: left;
}
.drop {
  cursor: pointer;
  position: absolute;
  z-index: 2;
  background-color: white;
  border: 1px solid var(--gray-300, #d1d5db);
  border-radius: 6px;
  width: 100%;
  top: 0;
  color: var(--gray-500, #6b7280);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.hide {
  display: none;
}
.selected {
  color: red;
}

.lds-dual-ring {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
}
.lds-dual-ring:after {
  content: ' ';
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #ef565b;
  border-color: #ef565b transparent #ef565b transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes ws_new_entry_bg_color {
  from {
    box-shadow: rgb(247, 0, 0) 0px 30px 60px -12px inset,
      rgb(255, 0, 0) 0px 18px 36px -18px inset;
  }
  to {
    box-shadow: transparent;
  }
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
